import { useState } from 'react'
import { combineImageWithStickers } from 'components/Selfiebooth/utils/canvas'

const usePhotoEditor = () => {
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [linkImg, setLinkImg] = useState<string|null>(null);

  const savePhotoWithStickers = async (
    photoUrl: string,
    stickers: any[],
    containerWidth: number,
    containerHeight: number,
    imageRotation: number = 0,
    watermark: any,
    method: 'camera'|'upload'
  ) => {
    try {
      setIsSaving(true);

      const finalImageUrl = await combineImageWithStickers(
        photoUrl,
        stickers,
        containerWidth,
        containerHeight,
        imageRotation,
        watermark,
        method
      );

      setLinkImg(finalImageUrl)
    } catch (e) {
      console.log('ERROR savePhotoWithStickers : ', e);
    } finally {
      setIsSaving(false);
    }
  };

  return { savePhotoWithStickers, isSaving, linkImg };
}

export default usePhotoEditor;